import { jwtDecode } from "jwt-decode";

import { localStorageKeys } from "./config";
import { LogSentryException } from "./sentryLogger";
import { clearUserIdCookie, setUserIdCookie } from "./userIdCookie";

export const getRefreshToken = (): string | null =>
  window.localStorage.getItem(localStorageKeys.refreshToken);

export const getAccessToken = (): string | null =>
  window.localStorage.getItem(localStorageKeys.accessToken);

export const isLoggedIn = (): boolean => {
  return getRefreshToken() !== null;
};

export type AuthResponseData = {
  id: string;
  email: string;
  refreshToken: string;
  accessToken: string;
  emailToken?: string;
};

export const getUserIdFromRefreshToken: () => string | null = () => {
  const refreshToken = getRefreshToken();

  if (!refreshToken) {
    return null;
  }
  try {
    const decodedToken: { sub: string } = jwtDecode(refreshToken);
    if (decodedToken && decodedToken.sub) {
      return decodedToken.sub;
    }
  } catch (error) {
    LogSentryException({ messagePrefix: "getUserIdFromRefreshToken", error });
    return null;
  }

  return null;
};

export const removeTokens = () => {
  window.localStorage.removeItem(localStorageKeys.refreshToken);
  window.localStorage.removeItem(localStorageKeys.accessToken);
  clearUserIdCookie();
};

export const setTokens = (refreshToken: string, accessToken: string) => {
  window.localStorage.setItem(localStorageKeys.refreshToken, refreshToken);
  window.localStorage.setItem(localStorageKeys.accessToken, accessToken);
  const userId = getUserIdFromRefreshToken();
  if (userId) {
    setUserIdCookie(userId);
  }
};
